import featherLight from "../../../libraries/featherlight.min";
import getUrlParameter from "./getUrlParameter";
import searchFocus from "./searchFocus";

export default function initDialogs() {
  searchFocus();
  featherLight();
  getUrlParameter();
  $.featherlight.defaults.afterOpen = function tabIndexFix() {
    var count = 1;

    $('.featherlight-content').find('input, select, textarea, button').each(function () {
      $(this).attr('tabindex', count++);
    });
    $('.featherlight-content .featherlight-close').attr("type", "button");
  }
  $.featherlight.defaults.afterClose = function () {
    searchFocus();
  }
  $.featherlight.defaults.beforeClose = function () {
    var callbackScript = $('.featherlight-content .featherlight-inner').data("callbackScript");
    if (callbackScript) {
      eval(callbackScript);
    }
  }
  $.featherlight.defaults.root = $(".featherlight-holder");
  $('.registration-popup-trigger').featherlight("#registration-dialog");
  $('.login-popup-trigger').featherlight("#login-dialog", { afterClose: function () { sessionStorage.clear() } });
  $('.send-review').featherlight("#review-form");
  if (getUrlParameter("showlogin")) {
    $.featherlight("#login-dialog");
    window.history.pushState("", "", removeParam("showlogin", window.location.href));
  }
}

export function showLoginDialog() {
  if ($('.login-popup-trigger').length > 0) {
    $('.login-popup-trigger').trigger("click")
  }
}